var map = {
	"./1.jpg": "./src/images/gallery/School Visit/1.jpg",
	"./10.jpg": "./src/images/gallery/School Visit/10.jpg",
	"./2.jpg": "./src/images/gallery/School Visit/2.jpg",
	"./3.jpg": "./src/images/gallery/School Visit/3.jpg",
	"./4.jpg": "./src/images/gallery/School Visit/4.jpg",
	"./5.jpg": "./src/images/gallery/School Visit/5.jpg",
	"./6.jpg": "./src/images/gallery/School Visit/6.jpg",
	"./7.jpg": "./src/images/gallery/School Visit/7.jpg",
	"./8.jpg": "./src/images/gallery/School Visit/8.jpg",
	"./9.jpg": "./src/images/gallery/School Visit/9.jpg",
	"./cover.jpg": "./src/images/gallery/School Visit/cover.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/gallery/School Visit sync \\.(png%7Cjpe?g%7Csvg)$";